import { Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild, } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BillingDetailsData, FinanceService } from 'src/shared/service-proxies/service-proxies';
import { PageHelperService } from '../helpers/page-helper.service';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import moment from 'moment';
import { SessionStorageService } from '../services/session-storage.service';
import { Router } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { LocalStorageService } from '../services/local-storage.service';
import { CustomerSettings } from '../services/customer-settings-service';
import { Observable, of } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import * as L from 'leaflet';
import * as R from 'leaflet-responsive-popup';
import { forEach } from '@angular-devkit/schematics';
import { AuthService } from '../security/auth.service';

export class DropDownListItem {
  constructor(id?: string, name?: string) {
    this.id = id,
    this.name = name;
  }

  id: string;
  name: string;
}

@Component({
    selector: 'app-billing-details-component',
    templateUrl: './billing-details.component.html',
    styleUrls: ['./billing-details.component.scss'],
    standalone: false
})
export class BillingDetailsComponent extends PagebaseComponent implements OnDestroy, OnInit {
  // Private variables
  data: BillingDetailsData;
  searchControl: UntypedFormControl = new UntypedFormControl();
  selectedStartDate: Date;
  selectedEndDate: Date;
  selectedShouldAllowNulls: boolean = false;
  selectedShouldIncludeDeletions: boolean = false;
  isFirstLoad: boolean = true;

  private apiCall;

  // Public variables
  loading: boolean = false;
  
  // Constuctor
  constructor(
    private _financeService: FinanceService,
    private sessionStorageService: SessionStorageService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private customerSettings: CustomerSettings,
    private authService: AuthService,
    pageHelperService: PageHelperService,
    applicationStatusService: ApplicationStatusService
    ) {
    super(pageHelperService, applicationStatusService, customerSettings, "Billing Details");
  }

  ngOnInit() {
    this.selectedStartDate = this.startDateChanged(this.getDefaultStartDate());
    this.selectedEndDate = this.endDateChanged(this.getDefaultEndDate());
  }

  ngOnDestroy(): void {
  }

  unsubscribe() { 
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }

  reset() {
    this.data = null;
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }

  getDefaultStartDate() {
    let date = new Date();

    date.setDate(date.getDate() - 6);
    date.setHours(0, 0, 0, 0);

    return date;
  }

  getDefaultEndDate() {
    let date = new Date();

    date.setHours(23, 59, 59, 999);

    return date;
  }

  // Get the view data
  getData() {
    this.data = null;

    console.log("loading data");
    this.loading = true;
    this.setIsLoading(this.loading);

    let selectedStartDate = this.localStorageService.getItem("billing-details-selectedStartDate");
    if(selectedStartDate) {
      selectedStartDate = JSON.parse(selectedStartDate);
      this.selectedStartDate = new Date(selectedStartDate);
    }
    else {
      selectedStartDate = "";
      this.selectedStartDate = null;
    }

    let selectedEndDate = this.localStorageService.getItem("billing-details-selectedEndDate");
    if(selectedEndDate) {
      selectedEndDate = JSON.parse(selectedEndDate);
      this.selectedEndDate = new Date(selectedEndDate);
    }
    else {
      selectedEndDate = "";
      this.selectedEndDate = null;
    }

    this.apiCall = this._financeService
      .getBillingDetails(
        this.isFirstLoad ? moment() : this.getSelectedDate(selectedStartDate),
        this.isFirstLoad ? moment() : this.getSelectedDate(selectedEndDate),
        this.selectedShouldAllowNulls,
        this.selectedShouldIncludeDeletions,
      )
      .subscribe(data => {
        this.data = data;    
        this.loading = false;
        this.setIsLoading(this.loading);
      }, error => {
        debugger;
      });
  }

  exportData() {
    this.loading = true;
    this.setIsLoading(this.loading);

    let selectedStartDate = this.localStorageService.getItem("billing-details-selectedStartDate");
    if(selectedStartDate) {
      selectedStartDate = JSON.parse(selectedStartDate);
      this.selectedStartDate = new Date(selectedStartDate);
    }
    else {
      selectedStartDate = "";
      this.selectedStartDate = null;
    }

    let selectedEndDate = this.localStorageService.getItem("billing-details-selectedEndDate");
    if(selectedEndDate) {
      selectedEndDate = JSON.parse(selectedEndDate);
      this.selectedEndDate = new Date(selectedEndDate);
    }
    else {
      selectedEndDate = "";
      this.selectedEndDate = null;
    }

    this.apiCall = this._financeService
      .exportBillingDetails(
        this.getSelectedDate(selectedStartDate),
        this.getSelectedDate(selectedEndDate),
        this.selectedShouldAllowNulls,
        this.selectedShouldIncludeDeletions,
      )
      .subscribe(data => {
        this.loading = false;
        this.setIsLoading(this.loading);
        let filename = data.fileName;
        let blob: Blob = data.data;
        let a = document.createElement('a');
        a.download = filename;
        a.href = window.URL.createObjectURL(blob);
        a.click();
      }, error => {
        debugger;
      });
  }

  selectedDatesChanged(startDate, endDate) {
    if (!startDate?.value) {
      this.localStorageService.removeItem("billing-details-selectedStartDate");
    }

    if (!endDate?.value) {
      this.localStorageService.removeItem("billing-details-selectedEndDate");
    }

    if (startDate?.value && endDate?.value) {
      var startMoment = moment(startDate.value, 'DD/MM/YYYY');
      var endMoment = moment(endDate.value, 'DD/MM/YYYY');
      startDate = startMoment.toDate();
      endDate = endMoment.toDate();

      var utcStart = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0));
      this.localStorageService.setItem("billing-details-selectedStartDate", utcStart.valueOf().toString());
      console.log(startDate)
      console.log(this.selectedStartDate)

      var utcEnd = new Date(Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, 0, 0));
      this.localStorageService.setItem("billing-details-selectedEndDate", utcEnd.valueOf().toString());
    }
  }

  getSelectedDate(selectedDate: string) {
    if (!selectedDate) {
      return null;
    }

    return moment(selectedDate);
  }

  refreshData() {
    this.isFirstLoad = false;

    this.getData();
  }

  startDateChanged(eventDate) {
    var date = !!eventDate ? new Date(eventDate) : null;
    
    if (!date) {
      this.localStorageService.removeItem("billing-details-selectedStartDate");
    }

    if (date) {
      var utc = new Date(Date.UTC(date.getFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()));

      this.localStorageService.setItem("billing-details-selectedStartDate", utc.valueOf().toString());
    }

    return date;
  }

  endDateChanged(eventDate) {
    var date = !!eventDate ? new Date(eventDate) : null;
    
    if (!date) {
      this.localStorageService.removeItem("billing-details-selectedEndDate");
    }

    if (date) {
      var utc = new Date(Date.UTC(date.getFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()));

      this.localStorageService.setItem("billing-details-selectedEndDate", utc.valueOf().toString());
    }

    return date;
  }
}